export enum TabLabels {
  AllResults = "results.allResults",
  MyCompleteResults = "results.myCompleteResults",
  MyPartialResults = "results.myPartialResults",
}
